import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/apps/incluipcd/src/blocks/Home/EventCountdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/apps/incluipcd/src/blocks/Home/FAQ.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/packages/ui/IncluiPCD/Content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/egalite-incluipcd/egalite-incluipcd/packages/ui/IncluiPCD/Home/Opportunities/OpportunitiesList.tsx");
